import React, { Component } from 'react';
import Moment from 'react-moment';

class Clock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: new Date(),
    };
  }

  componentDidMount() {
    this.intervalID = setInterval(() => this.tick(), 30000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  tick() {
    this.setState({
      time: new Date(),
    });
  }

  render() {
    return (
      <Moment locale="en" format="DD MMM YYYY HH:mm">
        {this.state.time}
      </Moment>
    );
  }
}
export default Clock;
